import { RouterProvider } from "@tanstack/react-router";
import { useMemo } from "react";
import { createQueryClient } from "@/lib/query-client";
import { AppProviders } from "./providers";
import { createAppRouter } from "./router";

export function App() {
  const queryClient = useMemo(() => createQueryClient(), []);
  const router = useMemo(() => createAppRouter(queryClient), [queryClient]);
  return (
    <AppProviders queryClient={queryClient}>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
